<script>
import SendSupportRequestButton from '@/components/support-requests/send-support-request-button.vue'
import SendSupportRequestModal from '@/components/support-requests/send-support-request-modal.vue'

export default {
  name: 'GrouprevPublicFooter',
  components: { SendSupportRequestModal, SendSupportRequestButton }
}
</script>

<template>
  <div class="text-center flex justify-center gap-6 text-gray-600 text-xs my-8">
    <router-link :to="{ name: 'Home' }">
      Home
    </router-link>
    <router-link :to="{ name: 'StaticTermsOfUsePage' }">
      Terms of Use
    </router-link>
    <router-link :to="{ name: 'StaticPrivacyPolicyPage' }">
      Privacy Policy
    </router-link>
    <router-link :to="{ name: 'StaticDisclaimerPage' }">
      Disclaimer
    </router-link>
    <send-support-request-button class="hover:text-blue-600" @open-modal="$refs.publicSupportModal.open()">
      Request Support
    </send-support-request-button>
    <send-support-request-modal ref="publicSupportModal" />
  </div>
</template>

<style scoped>

</style>
